import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { JpmamVendorTabRail } from '../../../../../../../../../../features/vendor/jpmam/jpmam-vendor-tab-rail';
import { JpmamOrdersTable } from '../../../../../../../../../../features/vendor/jpmam/order/jpmam-orders-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/order/_order/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorJpmam,
      label: 'Orders',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorJpmam>,
  head: () => getPageHead('JPMAM Orders'),
  component: JpmamOrderList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <JpmamVendorTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
    />
  );
}

function JpmamOrderList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <JpmamOrdersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
